import { AxiosError } from 'axios'
import type { ApiError } from '@/types'

export function getMessageFrom400Body(data: unknown): string | null {
  if (!data || typeof data !== 'object') return null
  const obj = data as Record<string, unknown>
  if (typeof obj.detail === 'string') return obj.detail
  if (typeof obj.error === 'string') return obj.error
  for (const key of Object.keys(obj)) {
    const val = obj[key]
    if (typeof val === 'string') return val
    if (Array.isArray(val) && val.length > 0 && typeof val[0] === 'string') return val[0]
  }
  return null
}

export function getApiErrorMessage(error: unknown, fallback: string): string {
  if (error instanceof AxiosError) {
    const data = error.response?.data
    const msg = getMessageFrom400Body(data)
    if (msg) return msg
    const record = data as Record<string, unknown> | undefined
    if (record && typeof record.detail === 'string') return record.detail
    if (record && typeof record.message === 'string') return record.message
  }
  if (error instanceof Error) return error.message
  return fallback
}

export function handleApiError(error: unknown): ApiError {
  if (error instanceof AxiosError) {
    const data = error.response?.data as Record<string, unknown> | undefined
    const message =
      getMessageFrom400Body(data) ??
      (data?.message as string | undefined) ??
      error.message ??
      'Une erreur est survenue'
    return {
      message: typeof message === 'string' ? message : 'Une erreur est survenue',
      status: error.response?.status,
      errors: data?.errors as Record<string, string[]> | undefined,
    }
  }

  if (error instanceof Error) {
    return {
      message: error.message,
    }
  }

  return {
    message: 'Une erreur inattendue est survenue',
  }
}
